// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"405":"0abb7213","509":"aa964de5"}[chunkId] + ".chunk.js";
};